import Form from 'app/components/Form';

import {
  getSimpleJobs
} from 'app/services/jobs';

import {
  formatOptions
} from 'app/utils/options';

const MarketingForm = props => {
  const {
    marketing,
    onClose,
    onSubmit,
    action
  } = props;

  let header = null;
  if (action === 'update') {
    header = 'Edit Fields';
  }

  const getJobOptions = async (page = 1, perPage = 100, filter = null, id = null) => {
    let jobs = await getSimpleJobs();
    return formatOptions(jobs);
  }

  let fields = [];
  if (!marketing) {
    fields = fields.concat([
      { name: 'name', label: 'Name', type: 'text', value: marketing?.name },
    ]);
  }

  fields = fields.concat([
    { name: 'popup_header', label: 'Popup Header', type: 'text', value: marketing?.popup_header },
    { name: 'popup_caption', label: 'Popup Caption', type: 'text', value: marketing?.popup_caption },
    { name: 'popup_description', label: 'Popup Description', type: 'text', value: marketing?.popup_description },
  ]);

  if (marketing) {
    fields = fields.concat([
      { name: 'job_id', label: 'Job', type: 'autocomplete', value: marketing?.job_id, valueType: 'integer', getOptions: getJobOptions },
      { name: 'enabled', label: 'Enabled', type: 'checkbox', valueType: 'boolean', value: marketing?.enabled }
    ])
  }

  return (
    <Form {...{
      header,
      fields,
      action,
      onClose,
      onSubmit
    }} />
  );
}

export default MarketingForm;
